import * as React from "react";
import "../filters.scss";
import DateUtils from "../../../../utils/DateUtils";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import {none, option, Option} from "ts-option";
import DatePickerComponent from "../../../ui/datepicker/DatePickerComponent";
import {Moment} from "moment";
import {DateFilterType, DateFilterTypeName} from "./DateFilter";
import DateFilterModel from "../../../../model/workspace/DateFilterModel";
import moment = require("moment");

interface IProps {
	/**
	 * Input value
	 */
	value: Option<BetweenFilterModel>
	/**
	 * On change callback
	 * @param {Option<BetweenFilterModel>} value
	 */
	onChange: (value: Option<BetweenFilterModel>) => void
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: string
	/**
	 * On select button
	 * @param {string} id
	 */
	onSelectButton: (id: string) => void
}

interface IState {
	/**
	 * Picked start date for time range for "Between"
	 */
	startDate: Option<Moment>;
	/**
	 * Picked end date for time range for "Between"
	 */
	endDate: Option<Moment>;
}

export default class BetweenFilter extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			startDate: props.value.map(v => v.start),
			endDate: props.value.map(v => v.end)
		};
		this.onChangeDatePickerStartDate = this.onChangeDatePickerStartDate.bind(this);
		this.onChangeDatePickerEndDate = this.onChangeDatePickerEndDate.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.selectedRadioButtonId === this.radioButton.value &&
			nextProps.selectedRadioButtonId !== this.radioButton.value) {
			this.resetFilter();
		}
	}

	radioButton: IRadioButton = {
		label: DateFilterTypeName[DateFilterType.Between],
		disabled: false,
		value: DateFilterType.Between
	};

	render() {
		const radioButtonChecked = (this.props.selectedRadioButtonId === this.radioButton.value);
		return (
			<div className={"c-filter-dates_inputs_row"}>
				<RadioButton radioButton={this.radioButton}
							 onChange={() => this.props.onSelectButton(this.radioButton.value)}
							 checked={radioButtonChecked}/>
				<div className={"c-filter-dates_date-picker_start-date"}>
					<DatePickerComponent dateFormat={DateUtils.DATE_FORMAT}
										 value={this.state.startDate}
										 onChange={this.onChangeDatePickerStartDate}
										 disabled={!radioButtonChecked}/>
				</div>
				<label className={"t-body c-filter-dates_inputs_row_label"}>and</label>
				<div className={"c-filter-dates_date-picker"}>
					<DatePickerComponent dateFormat={DateUtils.DATE_FORMAT}
										 value={this.state.endDate}
										 onChange={this.onChangeDatePickerEndDate}
										 disabled={!radioButtonChecked || this.state.startDate.isEmpty}
										 minDate={this.state.startDate.orNull}/>
				</div>
			</div>
		);
	}

	/**
	 * On change in date picker select start date
	 */
	onChangeDatePickerStartDate(value: Option<Moment>) {
		this.setState({startDate: value}, this.onChange)
	}

	/**
	 * On change in date picker select end date
	 */
	onChangeDatePickerEndDate(value: Option<Moment>) {
		this.setState({endDate: value}, this.onChange)
	}

	onChange() {
		if (this.state.startDate.isDefined && this.state.endDate.isDefined) {
			this.props.onChange(option(new BetweenFilterModel(this.state.startDate.get, this.state.endDate.get)));
		}
		else {
			this.props.onChange(none);
		}
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({startDate: none, endDate: none});
	}
}

export class BetweenFilterModel extends DateFilterModel {
	constructor(public readonly    start: Moment,
		public readonly end: Moment) {
		super(DateFilterType.Between);
	}

	getDisplayValue(): string {
		return `${super.getDisplayValue()} ${this.start.format(DateUtils.DATE_FORMAT)} - ${this.end.format(
			DateUtils.DATE_FORMAT)}`;
	}

	toQueryJson(dateFormat?: string) {
		return [this.start.format(dateFormat), this.end.format(dateFormat)];
	}

	static fromJson(json: string[]) {
		return new BetweenFilterModel(moment(json[0]), moment(json[1]))
	}
}